// Studyo Today Backend
// Package studyo.today.classroom.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/classroom/v1/resources/course.proto (package studyo.today.classroom.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/classroom/v1/resources/course.proto.
 */
export const file_studyo_today_classroom_v1_resources_course = /*@__PURE__*/
  fileDesc("CjBzdHVkeW8vdG9kYXkvY2xhc3Nyb29tL3YxL3Jlc291cmNlcy9jb3Vyc2UucHJvdG8SI3N0dWR5by50b2RheS5jbGFzc3Jvb20udjEucmVzb3VyY2VzIokBCgZDb3Vyc2USGwoTY2xhc3Nyb29tX2NvdXJzZV9pZBgBIAEoCRIYChB0b2RheV9wbGFubmVyX2lkGAIgASgJEg0KBXRpdGxlGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhMKC2lzX3NlbGVjdGVkGAUgASgIEg8KB3NlY3Rpb24YBiABKAlCK6oCKFN0dWR5by5Ub2RheS5DbGFzc3Jvb20uR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.classroom.v1.resources.Course.
 * Use `create(CourseSchema)` to create a new message.
 */
export const CourseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_classroom_v1_resources_course, 0);

